import { PaymentPlan } from '@nemuru-eng/js-api-client';
import { SWRConfig } from 'swr';

import { PaymentPlanTableRow } from '@/components/modules/PaymentPlan/components/PaymentPlanTableSection/components/PaymentPlanTable/components/PaymentPlanTableRow';

interface PaymentPlanTableBodyProps {
  paymentPlan: PaymentPlan;
  editModeAllowed: boolean;
  tableProps: { classes; stickyCellStyle };
  paginationProps: {
    rowsPerPage: number;
    page: number;
  };
}

export const PaymentPlanTableBody = ({
  paymentPlan,
  editModeAllowed,
  tableProps,
  paginationProps,
}: PaymentPlanTableBodyProps) => {
  const { rowsPerPage, page } = paginationProps;
  return (
    <>
      <SWRConfig value={{ revalidateOnMount: true }}>
        {paymentPlan.lines
          .sort((a, b) => (a.quotaNumber > b.quotaNumber ? 1 : -1))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((paymentPlanLine, i) => (
            <PaymentPlanTableRow
              key={i}
              paymentPlan={paymentPlan}
              paymentPlanLine={paymentPlanLine}
              editModeAllowed={editModeAllowed}
              tableProps={tableProps}
            />
          ))}
      </SWRConfig>
    </>
  );
};
